import styled from 'styled-components';

const Clear = styled.div`
  clear: both;
`;

export default Clear;
